import { Icon } from "common/LegacyIcon";
import React from "react";
import styles from "./BlockOverlay.scss";

export const BlockOverlay = ({ children, onClose, ...props }) => (
  <section {...props} className={styles.BlockOverlay}>
    {children}
    <div className={styles.closeButton}>
      <Icon i="x" size={20} onClick={onClose} />
    </div>
  </section>
);
